/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetCustomerGusResponseDto } from '../models';
// @ts-ignore
import type { ValueTypeDto } from '../models';
/**
 * RestExternalCustomersApi - axios parameter creator
 */
export const RestExternalCustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get list of customers from external source
         * @param {string} value value
         * @param {ValueTypeDto} valueType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGusCustomer: async (value: string, valueType: ValueTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'value' is not null or undefined
            assertParamExists('getGusCustomer', 'value', value)
            // verify required parameter 'valueType' is not null or undefined
            assertParamExists('getGusCustomer', 'valueType', valueType)
            const localVarPath = `/api/external-customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }

            if (valueType !== undefined) {
                localVarQueryParameter['valueType'] = valueType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestExternalCustomersApi - functional programming interface
 */
export const RestExternalCustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestExternalCustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get list of customers from external source
         * @param {string} value value
         * @param {ValueTypeDto} valueType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGusCustomer(value: string, valueType: ValueTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomerGusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGusCustomer(value, valueType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestExternalCustomersApi.getGusCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestExternalCustomersApi - factory interface
 */
export const RestExternalCustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestExternalCustomersApiFp(configuration)
    return {
        /**
         * 
         * @summary Get list of customers from external source
         * @param {string} value value
         * @param {ValueTypeDto} valueType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGusCustomer(value: string, valueType: ValueTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<GetCustomerGusResponseDto> {
            return localVarFp.getGusCustomer(value, valueType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestExternalCustomersApi - interface
 */
export interface RestExternalCustomersApiInterface {
    /**
     * 
     * @summary Get list of customers from external source
     * @param {string} value value
     * @param {ValueTypeDto} valueType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGusCustomer(value: string, valueType: ValueTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<GetCustomerGusResponseDto>;

}

/**
 * RestExternalCustomersApi - object-oriented interface
 */
export class RestExternalCustomersApi extends BaseAPI implements RestExternalCustomersApiInterface {
    /**
     * 
     * @summary Get list of customers from external source
     * @param {string} value value
     * @param {ValueTypeDto} valueType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGusCustomer(value: string, valueType: ValueTypeDto, options?: RawAxiosRequestConfig) {
        return RestExternalCustomersApiFp(this.configuration).getGusCustomer(value, valueType, options).then((request) => request(this.axios, this.basePath));
    }
}

